module.exports = __webpack_public_path__ + "static/media/quiz.fa14264e.yaml";